import { FC, useEffect, useId } from 'react';

import { Icon } from '@shared/components/icons';

interface Props {
  content: string; // 답례글 내용
  linkUrl: string; // 쿠폰 교환 링크
  buttonTitle?: string; // 카카오 버튼 제목
  onShare?: () => void;
}

declare global {
  interface Window {
    Kakao: any;
  }
}

const KakaoShareGiftButton: FC<Props> = ({
  content,
  linkUrl,
  buttonTitle = '답례품 받기',
  onShare,
}) => {
  const { ShareKakao } = Icon();
  const kakao = window.Kakao;
  const buttonId = useId().replace(/:/g, '');

  useEffect(() => {
    if (kakao) {
      if (!kakao.isInitialized()) {
        kakao.init(process.env.REACT_APP_KAKAO_SHARE_JAVASCRIPT_KEY);
      }

      // 기존 버튼 정리
      kakao.Share.cleanup();

      kakao.Share.createDefaultButton({
        container: `#kakao-gift-share-${buttonId}`,
        objectType: 'text',
        text: content,
        buttonTitle: buttonTitle,
        link: {
          webUrl: linkUrl,
          mobileWebUrl: linkUrl,
        },
      });
    }
  }, [content, linkUrl, buttonTitle, kakao, buttonId]);

  return (
    <button id={`kakao-gift-share-${buttonId}`} onClick={() => onShare?.()}>
      <ShareKakao />
    </button>
  );
};

export default KakaoShareGiftButton;
